define("shared/utils/get-duplicate-hashtags", ["exports", "shared/utils/get-hashtags"], function (_exports, _getHashtags) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = getDuplicateHashtags;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/get-hashtags"eaimeta@70e063a35619d71f

  /**
   * @module Utils
   * @extends Utils
   *
   *
   * Finds all duplicate hashtags from the caption and first comment
   *
   * @method getDuplicateHashtags
   *
   * @param {String} caption caption hashtags
   * @param {String} firstComment first comment hashtags
   * @param {String} field subset of duplicates to return
   *
   * @returns {String} A comma separated string of duplicate hashtags.
   */
  function getDuplicateHashtags(caption, firstComment, field) {
    const captionHashtags = (0, _getHashtags.default)(caption);
    const commentHashtags = (0, _getHashtags.default)(firstComment);
    const allHashtags = [...captionHashtags, ...commentHashtags];

    if (allHashtags.length === new Set(allHashtags).size) {
      return '';
    }

    const inclusionSet = new Set(field === 'caption' ? captionHashtags : commentHashtags);
    const duplicateList = allHashtags.filter((value, index, collection) => collection.indexOf(value) === index && collection.includes(value, index + 1) && inclusionSet.has(value)).map(tag => "#".concat(tag)).join(', ');
    return duplicateList;
  }
});